import { render, staticRenderFns } from "./teamRecordList.vue?vue&type=template&id=500de1f4&scoped=true"
import script from "./teamRecordList.vue?vue&type=script&lang=js"
export * from "./teamRecordList.vue?vue&type=script&lang=js"
import style0 from "./teamRecordList.vue?vue&type=style&index=0&id=500de1f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500de1f4",
  null
  
)

export default component.exports